<template>
  <transition name="fade">
    <div class="t-modal" v-if="show">
      <div class="t-modal-content">
        <div class="t-modal-dialog">
          <button class="t-modal-close" @click="close()">
            <img src="../../assets/icons/icon_close_06.svg" alt="close modal">
          </button>

          <div class="t-modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TheModal',
  data() {
    return {
      show: false,
    }
  },
  methods: {
    close() {
      this.show = false
    },
    open() {
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.t-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0,0,0,.3);
  z-index: 9999;
  &-content {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
  }

  &-dialog {
    background-color: #fff;
    border-radius: 5px;
    position: relative;
    width: 555px;
    max-width: 100%;
    padding: 45px 0 35px;
  }

  &-close {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    outline: none;
    border: none;
    background-color: transparent;
    img {
      width: 100%;
      height: 100%; 
    }
  }
}
</style>